import {put, takeEvery, select, delay} from 'redux-saga/effects';
import {getDiscount} from 'new-actions/api.actions.ts';
import {
	ADD_MENU_ENTRY_TO_CART,
	CHANGE_ORDER_LINE_MODIFIERS,
	DEC_ORDER_LINE_QUANTITY,
	INC_ORDER_LINE_QUANTITY,
} from 'new-constants/order-line.constants';
import {getCartDataForDiscount} from 'helpers/purchase.helper.ts';
import {SET_PICKUP_DATE_TIME} from 'new-constants/order-time.constants';
import {SET_ORDER_TYPE_INITIAL} from 'new-constants/ordering-mode.constants';
import {SET_TIP_PERCENT, SET_USE_CASH_POINTS} from 'new-constants/purchase.constants';
import {APPLY_PROMOCODE_SUCCESS} from 'new-constants/api.constants';
import {
	getCurrentDeliveryAddressSelector,
	getCurrentOrderLinesSelector,
	getCurrentRestaurantIdSelector,
	getCurrentTableNumberSelector,
	getTipAmountSelector
} from '../selectors';
import {CHECKOUT} from 'new-constants/navigation.constants';
import {START} from 'new-constants/app-state.constants';
import {DONE_INCOMPATIBLE_CART_CONFIRMATION, OPEN_REGISTRATION_POPUP} from 'new-constants/popup.constants';
import {REPEAT_ORDER_SUCCESS} from "../constants/api.constants";
import {CANCEL_DISCOUNT_ERROR_MESSAGE} from '../constants/popup.constants';

function* checkDiscountSilently() {
	const state = yield select();

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (!currentRestaurantId) return null;

	const currentOrderLines = state.orderLine.cache[currentRestaurantId];

	if (!(currentOrderLines?.length > 0)) return null;

	const currentMenu = state.menu.cache.find(menu => menu.restaurantId === currentRestaurantId);
	const currentPurchase = state.purchase.cache[currentRestaurantId];
	const currentTableNumber = getCurrentTableNumberSelector(state);

	yield put(
		getDiscount(
			getCartDataForDiscount(
				currentRestaurantId,
				state.orderingMode,
				state.orderTime,
				currentOrderLines,
				currentMenu,
				currentPurchase,
				getCurrentDeliveryAddressSelector(state),
				currentTableNumber,
				getTipAmountSelector(state)
			),
			true
		)
	);
}

function* checkDiscountIfCartHasItems() {
	yield delay(2000);
	const state = yield select();

	if (getCurrentOrderLinesSelector(state).length > 0) {
		yield checkDiscountSilently();
	}
}

function* checkDiscount() {
	const state = yield select();

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (!currentRestaurantId) return null;

	const currentOrderLines = state.orderLine.cache[currentRestaurantId];

	if (!(currentOrderLines?.length > 0)) return null;

	const currentMenu = state.menu.cache.find(menu => menu.restaurantId === currentRestaurantId);
	const currentPurchase = state.purchase.cache[currentRestaurantId];
	const currentTableNumber = getCurrentTableNumberSelector(state);

	yield put(
		getDiscount(
			getCartDataForDiscount(
				currentRestaurantId,
				state.orderingMode,
				state.orderTime,
				currentOrderLines,
				currentMenu,
				currentPurchase,
				getCurrentDeliveryAddressSelector(state),
				currentTableNumber,
				getTipAmountSelector(state)
			)
		)
	);
}

export const orderLineSaga = function* orderLineSaga() {
	yield takeEvery(
		[
			INC_ORDER_LINE_QUANTITY,
			DEC_ORDER_LINE_QUANTITY,
			SET_ORDER_TYPE_INITIAL,
			SET_USE_CASH_POINTS,
			APPLY_PROMOCODE_SUCCESS,
			SET_TIP_PERCENT,
			CHANGE_ORDER_LINE_MODIFIERS,
			DONE_INCOMPATIBLE_CART_CONFIRMATION,
			REPEAT_ORDER_SUCCESS,
			CANCEL_DISCOUNT_ERROR_MESSAGE
		],
		checkDiscountSilently
	);
	yield takeEvery(
		[
			CHECKOUT,
			SET_PICKUP_DATE_TIME,
			action => action.type === ADD_MENU_ENTRY_TO_CART && action.isAddToCart,
			action => action.type === OPEN_REGISTRATION_POPUP && !action.showPopup,
		],
		checkDiscount
	);
	yield takeEvery([START], checkDiscountIfCartHasItems);
};
